var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terminal-bg"},[_c('div',{staticClass:"sheet"},[_c('h3',[_vm._v("生理参数检测报告")]),_c('div',{staticClass:"charts-wrap"},[_c('div',{ref:"points"}),_c('div',{ref:"line"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }